import styled from "styled-components";

const TrendingTitle = styled.div`
  color: #222;
  text-align: center;
  font-size: 50px;
  font-weight: 700;
  margin-bottom: 30px;
  text-transform: lowercase;

  @media (max-width: 1599px) {
    font-size: 35px;
    margin-bottom: 20px;
  }
  @media (max-width: 575px) {
    font-size: 20px;
    margin-bottom: 10px;
  }
`;
export default TrendingTitle;
